<p-dialog [header]="header" [(visible)]="visible" (onHide)="onDialogHide()" [modal]="modal" [styleClass]="styleClass"
    [blockScroll]="blockScroll" [closeOnEscape]="closeOnEscape" appendTo="body" [breakpoints]="breakpoints" [style]="contentStyleClass" [closable]="closable"
    [appendTo]="appendTo">
    <ng-content></ng-content>
</p-dialog>